import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Badge from 'material-ui/Badge';
import Button from '@material-ui/core/Button';
import EnvelopeIcon from 'material-ui/svg-icons/communication/email';
import './NavBar.css';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import { toggleChatDrawer } from 'actions/chatActions';

export default connect(
  store => ({
    todoData: store.todo.todoData,
    isLandlord: store.userTypes.isLandlord,
    showChatDrawer: store.chat.toggleChatDrawer,
  }),
  { toggleChatDrawer }
)(
  class ChatIcon extends Component {
    handleClick = event => {
      if (this.props.isLandlord) {
        return browserHistory.push('/companies/messaging');
      }

      this.props.toggleChatDrawer(!this.props.showChatDrawer);
    };

    render() {
      const messageData = this.props.todoData.filter(obj => obj.event_type === 'Messages')[0];
      const unreadMessages = !!messageData ? messageData.unread_messages : 0;

      const style = {
        badge_icon: {
          top: 3,
          right: -4,
          width: 16,
          height: 16,
          fontSize: 10,
          backgroundColor: AccentColor(),
        },
        notifications_icon: {
          height: 25,
          width: 25,
          color: colors.DARK_GRAY,
        },
        notifications_icon_no_badge: {
          height: 25,
          width: 25,
          color: colors.DARK_GRAY,
        },
        button: { padding: '8px', minWidth: '40px', color: colors.MENU_ITEM_GRAY },
      };

      return (
        <div>
          {unreadMessages > 0 && (
            <Button style={style.button} onClick={this.handleClick}>
              <Badge
                badgeContent={unreadMessages}
                secondary={true}
                style={{ padding: '6px 0 0 0' }}
                badgeStyle={style.badge_icon}
              >
                <EnvelopeIcon
                  onClick={this.handleTouchTap}
                  size={25}
                  style={style.notifications_icon}
                  id="chat_icon"
                />
              </Badge>
            </Button>
          )}
          {!unreadMessages && (
            <Button style={style.button} onClick={this.handleClick}>
              <EnvelopeIcon size={25} style={style.notifications_icon_no_badge} id="chat_icon" />
            </Button>
          )}
        </div>
      );
    }
  }
);
